<div class="step-content" *translateBlock="let t">
  <div class="quick-date">
    <span>{{ t('common.quick-selection.text') }}</span>

    <div class="actions">
      <app-button-icon [label]="t('common.quick-selection.one-day')"
                       iconName="calendar_today"
                       (click)="setDateRangeDay(1)" />
      <app-button-icon [label]="t('common.quick-selection.one-week')"
                       iconName="date_range"
                       (click)="setDateRangeDay(7)"  />
      <app-button-icon [label]="t('common.quick-selection.one-month')"
                       iconName="calendar_month"
                       (click)="setDateRangeMonth(1)"  />
    </div>
  </div>

  <div class="date-row">
    <div class="date-field">
      <app-input-calendar [formData]="dateFromConfig" />
    </div>

    <div class="date-field">
      <app-input-calendar [formData]="dateToConfig" />
    </div>
  </div>
</div>
